import { useFetchWrapper } from '_helpers';

export { useNotificationActions };

function useNotificationActions() {
    const fetchWrapper = useFetchWrapper();

    /** Staff: send a notification. payload = { target, kind?, class_id?, student_ids?, title?, body? } */
    async function sendNotification(payload) {
        const res = await fetchWrapper.post('/api/notifications/send', 'application/json', JSON.stringify(payload));
        return res.json();
    }

    /** Staff: one-click low-balance tuition reminder for a single student (by ME… code). */
    async function sendTuitionReminder(student_id) {
        const res = await fetchWrapper.post('/api/notifications/tuition', 'application/json', JSON.stringify({ student_id }));
        return res.json();
    }

    /** Anyone: the caller's own notifications, newest first. */
    async function getMyNotifications() {
        const res = await fetchWrapper.get('/api/notifications/me', null, null);
        if (!res) return [];
        const json = await res.json();
        return json.status === 'Success' ? json.message : [];
    }

    async function getUnreadCount() {
        const res = await fetchWrapper.get('/api/notifications/unread-count', null, null);
        if (!res) return 0;
        const json = await res.json();
        return json.status === 'Success' ? (json.message?.count || 0) : 0;
    }

    async function markRead(id) {
        const res = await fetch(`/api/notifications/${id}/read`, { method: 'PATCH', credentials: 'include' });
        if (!res) return null;
        try { return await res.json(); } catch (e) { return null; }
    }

    async function markAllRead() {
        const res = await fetch('/api/notifications/read-all', { method: 'PATCH', credentials: 'include' });
        try { return await res.json(); } catch (e) { return null; }
    }

    /** Staff: classes the caller teaches (for the recipient picker). */
    async function getMyClasses() {
        const res = await fetchWrapper.get('/api/classes/me', null, null);
        if (!res) return [];
        const json = await res.json();
        return json.status === 'Success' ? (json.message || []) : [];
    }

    /** Managers: teachers (for the specific-teacher picker). */
    async function getTeachers() {
        const res = await fetchWrapper.get('/api/manager/teachers', null, null);
        if (!res) return [];
        const json = await res.json();
        const list = json.status === 'Success' ? (json.message || []) : [];
        return list.filter(u => u.role === 'teacher');
    }

    /** Staff: student members of a class (for the specific-students picker). */
    async function getClassMembers(classId) {
        const res = await fetchWrapper.get(`/api/classes/${classId}/members/infors`, null, null);
        if (!res) return [];
        const json = await res.json();
        return json.status === 'Success' ? (json.message || []) : [];
    }

    return {
        sendNotification,
        sendTuitionReminder,
        getMyNotifications,
        getUnreadCount,
        markRead,
        markAllRead,
        getMyClasses,
        getTeachers,
        getClassMembers,
    };
}
